<div id="wallboard-config">
  
  <label class="uk-form-label rotationlabel">Site Name</label>
  <input [ngClass]="[(wallboardService.activeQueueConfig.View.trim().length > 0) ? 'uk-input' : 'uk-input uk-form-danger']" [(ngModel)]="wallboardService.activeQueueConfig.View" (ngModelChange)="validateInput()">

  <div class="aggselector">
    <input type="checkbox" class="uk-checkbox" name="aggregate" (change)="toggleAggregateView(wallboardService.activeQueueConfig.AggregateView)" [(ngModel)]="wallboardService.activeQueueConfig.AggregateView">
    Aggregate View
  </div>
  
  <div class="queue-select" *ngIf="!wallboardService.activeQueueConfig.AggregateView">
    <label class="uk-form-label rotationlabel">Queue Name</label>
    <select 
      class="uk-select" 
      [ngClass]="[(wallboardService.activeQueueConfig.QueueName != '') ? 'uk-select': 'uk-select uk-form-danger']" 
      [(ngModel)]="wallboardService.activeQueueConfig.QueueName" 
      (change)="updateQueueARN(queueName.value); validateInput()" 
      #queueName>
      <option value="">Select Queue</option>
      <option *ngFor="let queue of configService.queueNamesList">
        {{ queue.queueName }}
      </option>
    </select>
  </div>

  <div class="uk-margin" *ngIf="wallboardService.activeQueueConfig.AggregateView && wallboardService.activeQueueConfig.View">
    <label class="uk-form-label rotationlabel">Refresh Interval</label>
    <input class="refresh-interval-slider" type="range" min="5" max="45" list="steplist" [(ngModel)]="wallboardService.activeQueueConfig.RefreshInterval" name="rotationDelay">
    <datalist id="steplist">
      <option>5</option>
      <option>10</option>
      <option>15</option>
      <option>20</option>
      <option>25</option>
      <option>30</option>
      <option>35</option>
      <option>40</option>
      <option>45</option>
    </datalist>
    <app-time-display secondsOnly="true" [timeInSeconds]="wallboardService.activeQueueConfig.RefreshInterval"></app-time-display>
  </div>

  <div class="uk-margin" *ngIf="wallboardService.activeQueueConfig.AggregateView && wallboardService.activeQueueConfig.View">
    <label class="uk-form-label rotationlabel">Announcements</label>
    <input type="text" [(ngModel)]="wallboardService.activeQueueConfig.Announcements">
  </div>

  <div class="config-container">
    <form #wallboardConfig="ngForm">

      <div class="config-container" *ngIf="wallboardService.activeQueueConfig.QueueName && !wallboardService.activeQueueConfig.AggregateView">
        <app-wb-config
          [activeConfig]="wallboardService.activeQueueConfig"
          [aggregate]="false"
          (validationChange)="validateInput()"
          *ngIf="!wallboardService.activeQueueConfig.AggregateView">
        </app-wb-config>
      </div>

      <div class="config-container" *ngIf="wallboardService.activeQueueConfig.View && wallboardService.activeQueueConfig.AggregateView">
        <app-wb-config
          [activeConfig]="wallboardService.activeQueueConfig.LeftPane"
          [aggregate]="true"
          (validationChange)="validateInput()"
          *ngIf="wallboardService.activeQueueConfig.AggregateView">
        </app-wb-config>
        <app-wb-config
          [activeConfig]="wallboardService.activeQueueConfig.RightPane"
          [aggregate]="true"
          (validationChange)="validateInput()"
          *ngIf="wallboardService.activeQueueConfig.AggregateView">
        </app-wb-config>
      </div>
      <div fxLayoutGap="10px">
        <button mat-raised-button color="primary" (click)="postConfig()" [disabled]="!formValid">SUBMIT</button>
        <button mat-raised-button color="accent" (click)="cancelSite(configService.activeLOB)">CANCEL</button>
      </div>
    </form>
  </div>
</div>